import { makeContext } from "../make";

export const {
  Context: NearbyDrawerOpenContext,
  useContext: useNearbyDrawerOpenContext,
  Provider: NearbyDrawerOpenProvider,
} = makeContext("NearbyDrawerOpen", false);
